"use strict";
/**
 * client.ts
 *
 * Utilities related to enabling application context on the client.
 *
 * This file is currently duplicated in the following packages:
 *
 * - packages/ud-api/src/app-context.ts
 * - packages/react-header/src/external/app-context.ts
 *
 * This is to avoid coupling between legacy componennts and this package.
 *
 * TODO: create an `AppContextProvider` package and move this code there
 * and send dependencies to that package
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_CONTEXT_PRESENT_SCRIPT = exports.APP_CONTEXT_VAR_PRESENT = exports.APP_CONTEXT_VAR_NAME = void 0;
exports.isAppContextOnClientSupported = isAppContextOnClientSupported;
exports.getClientAppContext = getClientAppContext;
// Define a constant for the global variable to name on the client to handoff app context.
exports.APP_CONTEXT_VAR_NAME = '__UDMY_APP_CONTEXT';
exports.APP_CONTEXT_VAR_PRESENT = '__UDMY_APP_CONTEXT_PRESENT';
exports.APP_CONTEXT_PRESENT_SCRIPT = `window.${exports.APP_CONTEXT_VAR_PRESENT} = true;`;
/**
 * isAppContextOnClientSupported()
 *
 * Application that returns true if application context is expected to be written to the global scope.
 *
 * if (isAppContextOnClientSupported()) {
 *     const appContext = await getClientAppContext();
 * } else {
 *     // Fallback to legacy fetch
 *     appContext = await fetchCommonAppData();
 * }
 *
 */
function isAppContextOnClientSupported() {
    if (global.window && global.window[exports.APP_CONTEXT_VAR_PRESENT]) {
        return true;
    }
}
/**
 * getClientAppContext()
 *
 * This function is meant to be only executed on the client browser.  It's responsible
 * reading the app context from `window[APP_CONTEXT_VAR_NAME]` that is set by
 * a script tag defined in the <head /> of the document.  This massively optimizes the priority
 * of all the requests that are defined here.
 *
 */
function getClientAppContext() {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined') {
            throw new Error('Cannot use `getClientAppContext()` server-side');
        }
        return new Promise((resolve) => {
            function resolvePageContext() {
                const APP_CONTEXT = window[exports.APP_CONTEXT_VAR_NAME];
                if (APP_CONTEXT) {
                    resolve(APP_CONTEXT);
                }
                else {
                    setTimeout(resolvePageContext, 100);
                }
            }
            resolvePageContext();
        });
    });
}
//# sourceMappingURL=client.js.map